<template>
  <Modal :value="visible" @input="(v) => $emit('update:visible', v)" title="编辑提示词并重新生成" width="580px"
    :mask-closable="false" class-name="ai-regenerate-modal">
    <div class="ai-regenerate-body">
      <div class="ai-regenerate-tip">
        <Icon type="ios-information-circle-outline" />
        <span>修改提示词后，将对该图片重新调用 AI 生成接口</span>
      </div>
      <div class="ai-regenerate-field">
        <!-- <div class="ai-regenerate-label">提示词 (Prompt)</div> -->
        <Input type="textarea" v-model="prompt" :rows="6" placeholder="请输入提示词..." />
      </div>
    </div>

    <div slot="footer">
      <Button @click="$emit('update:visible', false)">取消</Button>
      <Button type="primary" :loading="loading" :disabled="!prompt || !prompt.trim()"
        @click="handleGenerate">立即生成</Button>
    </div>
  </Modal>
</template>

<script>
import api from "@/api/api";

/**
 * @description AI 生图 - 编辑提示词并重新生成弹框
 * @author 前端开发
 * @date 2026-09-08
 * @功能说明
 *   1. 展示当前 lineage 的原提示词供编辑
 *   2. 点击"立即生成"调用重新生成接口（占位，后端接口待定）
 *   3. 成功后 emit('success') 让父组件刷新列表
 */
export default {
  name: "aiRegenerateModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    task: {
      type: Object,
      default: null,
    },
    lineage: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      prompt: "",
      loading: false,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        // 弹框打开时，用当前 lineage 的 prompt 初始化
        this.prompt = this.lineage && this.lineage.prompt ? this.lineage.prompt : "";
      }
    },
  },
  methods: {
    handleGenerate() {
      if (!this.prompt || !this.prompt.trim()) {
        this.$Message.warning("提示词不能为空");
        return;
      }
      const taskId = this.task && this.task.aiGenerateImageTaskId;
      const detailId = this.lineage && this.lineage.aiGenerateImageTaskDetailId;
      if (!taskId || !detailId) {
        this.$Message.error("缺少任务ID，无法重新生成");
        return;
      }
      if (this.loading) return;

      this.loading = true;
      this.axios
        .post(api.aiGenerateImageTaskRetry, {
          aiGenerateImageTaskId: taskId,
          aiGenerateImageTaskDetailId: detailId,
          prompt: this.prompt.trim(),
        })
        .then((res) => {
          if (res && res.data && res.data.code == 0) {
            this.$Message.success("重新生成任务已提交");
            this.$emit("success");
          } else {
            this.$Message.error((res && res.data && res.data.message) || "重新生成失败");
          }
        })
        .catch(() => {
          this.$Message.error("重新生成失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped lang="less">
.ai-regenerate-body {
  padding: 4px 2px;
}

.ai-regenerate-tip {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #808695;
  background: #f7f9fc;
  padding: 8px 12px;
  border-radius: 4px;
  margin-bottom: 14px;

  i {
    color: #2d8cf0;
    font-size: 14px;
  }
}

.ai-regenerate-field {
  .ai-regenerate-label {
    font-size: 13px;
    font-weight: 600;
    color: #17233d;
    margin-bottom: 6px;
  }
}
</style>
